// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__16OoU","label":"LabeledBox_label__1oD1J"};